import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from "../services/auth.service";

@Injectable()
export class AllRolesAuthGuard  {

  constructor(private authService: AuthService, private router: Router) {
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(childRoute, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let requiredRoles = route.data.roles as Array<string>;

    requiredRoles.forEach(role => {
      if (!this.authService.hasRole(role)) {
        this.router.navigate(["/unauthorised"]);
      }
    })

    return true;
  }
}
